import FarmList from '../../views/Farm/FarmList';
import FarmEdit from '../../views/Farm/FarmEdit';

export default [
    {
        path: '/fazendas',
        name: 'farm.list',
        component: FarmList,
        meta: {
            pageTitle: 'Fazendas',
            breadcrumb: [
                { label: 'Fazendas' },
            ],
        },
    },
    {
        path: '/fazendas/cadastro',
        name: 'farm.create',
        component: FarmEdit,
        meta: {
            pageTitle: 'Cadastro de Fazenda',
            breadcrumb: [
                { label: 'Fazendas', routeName: 'farm.list' },
                { label: 'Cadastro de Fazenda' },
            ],
        },
    },
    {
        path: '/fazendas/:id',
        name: 'farm.edit',
        component: FarmEdit,
        meta: {
            pageTitle: 'Edição de Fazenda',
            breadcrumb: [
                { label: 'Fazendas', routeName: 'farm.list' },
                { label: 'Edição de Fazenda' },
            ],
        },
    },
];
